export default {
  pt: {
    pageTitle: "Advertência",
    warningTitle: "Advertência!",
    warningText1:
      "Este seguro exige que o segurado/beneficiário seja o destinatário da nota fiscal.",
    warningText2: "Identificamos que o CPF informado é diferente do constante na nota fiscal.",
    warningText3:
      "Você pode prosseguir; porém, em caso de sinistro, será obrigatória a comprovação da propriedade do bem. A não apresentação de documentação válida poderá resultar na negativa de indenização.",
    warningText4: "Ao prosseguir, você declara estar ciente e de acordo com essas condições.",
    warningText5: "Opções para liberação:",
    freeWarningText1:
      "Este programa de seguros exige que o segurado ou beneficiário seja o destinatário da nota fiscal, sendo o protocolo realizado em seu nome.",
    freeWarningText2:
      "A contratação deverá ser feita obrigatoriamente pelo destinatário ou por seu representante legal.",
    freeWarningText3:
      "Se o destinatário for menor de idade, a contratação deve ser feita apenas por seu representante legal.",
    freeWarningText4:
      "Em caso de sinistro, a reposição será feita diretamente ao destinatário. Para menores de idade, a reposição será realizada ao representante legal.",
    freeRadioLabel:
      "Sou cônjuge, descendente ou ascendente do destinatário da nota fiscal.",
    checkboxRelationship:
      "Declaro que sou cônjuge, ascendente ou descendente do destinatário da nota fiscal e posso comprovar esse vínculo, se necessário",
    checkboxOwner: "Declaro que sou o legítimo proprietário do bem",
    checkboxDocumentation:
      "Declaro que possuo documentação válida para comprovar a propriedade em caso de sinistro",
    checkboxCompensationAware:
      "Declaro que estou ciente de que a falta dessa comprovação poderá resultar na negativa de indenização",
    backButton: "Voltar",
    continueButton: "Continuar",
  },
  en: {
    pageTitle: "Divergence Warning",
    warningTitle: "Warning!",
    warningText1:
      "This insurance requires that the insured/beneficiary be the recipient of the invoice.",
    warningText2:
      "We have identified that the CPF (Brazilian tax identification number) provided is different from the one on the invoice.",
    warningText3:
      "You may proceed; however, in the event of a claim, proof of ownership of the item will be mandatory. Failure to present valid documentation may result in denial of compensation.",
    warningText4: "By proceeding, you declare that you are aware of and agree to these conditions.",
    warningText5: "Options for release:",
    freeWarningText1:
      "This insurance program requires that the insured or beneficiary be the recipient of the tax invoice, with the protocol carried out in their name.",
    freeWarningText2:
      "The contract must be made obligatorily by the recipient or their legal representative.",
    freeWarningText3:
      "If the recipient is a minor, the contract must be made only by their legal representative.",
    freeWarningText4:
      "In case of loss, replacement will be made directly to the recipient. For minors, replacement will be made to the legal representative.",
    freeRadioLabel:
      "I am a spouse, descendant or ascendant of the tax invoice recipient.",
    checkboxRelationship:
      "I declare that I am the spouse, ascendant or descendant of the tax invoice recipient and can prove this relationship, if necessary",
    checkboxOwner: "I declare that I am the legitimate owner of the item",
    checkboxDocumentation:
      "I declare that I have valid documentation to prove ownership in the event of a claim",
    checkboxCompensationAware:
      "I declare that I am aware that failure to provide this proof may result in denial of compensation",
    backButton: "Back",
    continueButton: "Continue",
  },
};
